import { SET_ORDERS, CLEAR_ORDERS } from "./ordersActions";
import { ordersType } from "../../components/account/types";

export interface OrdersState {
    all: ordersType[];
    downloadable: ordersType[];
}

const initialState: OrdersState = {
    all: [],
    downloadable: [],
};

const ordersReducer = (state: OrdersState = initialState,
                       action: any): OrdersState => {
    switch (action.type) {
        case SET_ORDERS:
            const allOrders: ordersType[] = action.payload;
            const downloadableOrders = allOrders.filter(order =>
                order.items.some(item => item.type === "downloadable")
            );
            return {
                ...state,
                all: allOrders,
                downloadable: downloadableOrders
            };
        case CLEAR_ORDERS:
            return {
                all: [],
                downloadable: [],
            };
        default:
            return state;
    }
};

export default ordersReducer;
